import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { TeamStore } from "@app/services/store/team-store";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { Planner } from "@app/models/rest/planner";
import { Team } from "@app/models/rest/team";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { firstValueFrom } from "rxjs";
import { MatButton } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-planner-team-editor",
  templateUrl: "./planner-team-editor.component.html",
  styleUrls: ["./planner-team-editor.component.css"],
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatSelectionList,
    MatListOption,
    MatButton,
    FormsModule,
    TranslatePipe,
    DialogHeaderComponent
  ]
})
export class PlannerTeamEditorComponent implements OnInit {
  private teamStore = inject(TeamStore);
  dialogRef =
    inject<MatDialogRef<PlannerTeamEditorComponent, boolean>>(MatDialogRef);
  private serviceErrorHandler = inject(ServiceErrorHandlerService);
  data = inject<{
    planner: Planner;
  }>(MAT_DIALOG_DATA);

  @ViewChild("teamSelection", { static: false })
  teamSelection: MatSelectionList;

  teams: Team[] = [];
  selectedOptions: Team[] = [];

  // Compare function to properly match teams by ID
  compareFunction = (o1: Team, o2: Team) => o1.id === o2.id;

  ngOnInit(): void {
    // Set initial selections from planner data
    this.selectedOptions = this.data.planner?.teamList || [];

    // Load all available teams
    this.teamStore
      .loadAll()
      .then((value) => {
        this.teams = value.resources;
      })
      .catch((error) => {
        this.serviceErrorHandler.handleClientError(error);
      });
  }

  /**
   * Save the selected teams to the planner
   */
  save(): void {
    const planner: Planner = this.data.planner;

    // First clear existing team relations
    firstValueFrom(planner.unbindCollectionRelation("teamList"))
      .then(() => {
        // Then add selected teams if there are any
        if (this.selectedOptions.length > 0) {
          // Need to return void to satisfy TypeScript
          return firstValueFrom(
            planner.addCollectionRelation("teamList", this.selectedOptions)
          ).then(() => {});
        }
        return;
      })
      .then(() => {
        // Close dialog with success
        this.dialogRef.close(true);
      })
      .catch((error) => {
        this.serviceErrorHandler.handleClientError(error);
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
